import { Zap, Crown } from "lucide-react";

// Shared pricing data. Every plan grants the SAME unlimited generation —
// plans differ only by billing interval.
export const UNLIMITED_NOTE =
  "Weekly, monthly, and yearly plans renew automatically until canceled.";

// Free-tier hard caps (cumulative characters). Mirrors backend LIMIT_HIGH / LIMIT_LOW.
export const FREE_LIMITS = { high: 30000, low: 50000 };

export const INTRO_OFFER = {
  key: "vox_weekly_intro",
  firstPrice: "$1",
  firstDuration: "first 7 days",
  renewalPrice: "$5.99/week",
};

export const PLANS = [
  {
    key: "vox_weekly",
    name: "Weekly",
    price: "$5.99",
    per: "/week",
    duration: "Renews every 7 days",
    icon: Zap,
    perks: [
      "Unlimited generations",
      "Both engines: Low & High Quality",
      "Unlimited WAV exports",
      "Cancel anytime in billing",
    ],
    cta: "Choose Weekly",
  },
  {
    key: "vox_monthly",
    name: "Monthly",
    price: "$19.99",
    per: "/month",
    duration: "Renews every month",
    icon: Zap,
    perks: [
      "Unlimited generations",
      "Both engines: Low & High Quality",
      "Unlimited WAV exports",
      "Cancel anytime in billing",
    ],
    cta: "Choose Monthly",
  },
  {
    key: "vox_yearly",
    name: "Yearly",
    price: "$99",
    per: "/year",
    duration: "Renews every year",
    icon: Crown,
    featured: true,
    badge: "BEST VALUE",
    perks: [
      "Unlimited generations",
      "Both engines: Low & High Quality",
      "Unlimited WAV exports",
      "Cancel anytime in billing",
    ],
    cta: "Choose Yearly",
  },
];
